<div class="card card-custom gutter-b card-fit" data-card="true" id="kt_card_1">
    <div class="card-header">
        <div class="card-title">
           
        </div>
        <div class="card-toolbar">

            <button type="button" class="btn btn-sm  btn-secondary mr-2 font-weight-bold">
                <i class="fas fa-filter icon-sm"></i>Filter
            </button>

            <button type="button" class="btn btn-sm btn-primary font-weight-bold" (click)="add()">
                <!--begin::Svg Icon | path: icons/duotune/general/gen031.svg-->
                <i class="fas fa-plus icon-sm"></i>Add Family
            </button>
        </div>
    </div>
    <div class="card-body  mt-0 py-0 px-5">
        
        <div class="table-responsive max-h-500px ">
            <table class="table table-bordered  table-sm rounded">
                <thead class="thead-light">
                    <tr>
                        <th>Full Name</th>
                        <th>Relation</th>
                        <th>Home Phone</th>
                        <th>Work Phone</th>
                        <th class="text-center min-w-100px ">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="clientService.client_family.length === 0">
                        <td colspan="5">No information available</td>

                    </tr>

                    <tr *ngFor="let item of clientService.client_family">

                        <td>
                            <span class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg"
                                (click)="edit(item)">
                                {{ item.first_name }} {{ item.last_name }}
                            </span>
                        </td>
                        <td>
                            {{ item.relation }}
                        </td>
                        
                        <td>
                            {{ item.home_phone }}
                        </td>
                        <td>
                            {{ item.work_phone }} {{ item.work_phone_ext }}
                        </td>

                       
                        <td class="text-center ">
                            <button type="button" class="btn btn-icon btn-secondary btn-sm mx-1 my-0" (click)="edit(item)">
                                <i class="la la-pen"></i>
                            </button>
                            <button type="button" class="btn btn-icon btn-danger btn-sm btn-hover-danger my-0 mx-1"
                                (click)="delete(item)">
                                <i class="la la-trash"></i>
                            </button>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</div>